import { createFileRoute } from "@tanstack/react-router";

import { addressedProject, started } from "../../lib/prefetch";
import { ProjectScope } from "../../workspaces/projects/ProjectScope";

export const Route = createFileRoute("/_console/p/$org/$project")({
  // The project's crew, read on the click under the Agents tree's own key: the rail's Crew
  // and the Agents tree share this one read, so the rail never starts a read of its own. A
  // customer participant has no crew, so nothing starts for one.
  loader: ({ context: { queryClient }, params }) => {
    void started(
      (async () => {
        const [project, { isCustomerParticipantRole }, { teamRosterQuery }] = await Promise.all([
          addressedProject(queryClient, params),
          import("../../lib/access"),
          import("../../workspaces/agents/api"),
        ]);
        if (project === undefined || isCustomerParticipantRole(project.managedAccessRole)) return;
        await queryClient.prefetchQuery(teamRosterQuery(project.id));
      })(),
    );
  },
  component: ProjectScope,
});
